import { StatusStreamTypes } from "../Store/modules/streamedChat/streamedChat";

export function* streamStatusUtil(
  buffer: string,
  action: (payload: StatusStreamTypes) => Generator,
) {
  switch (buffer) {
    case "created":
      yield action({
        label: "streamingStatuses.created",
        status: "created",
      });
      break;
    case "in_progress":
      yield action({
        label: "streamingStatuses.in_progress",
        status: "in_progress",
        delay: 1500,
      });
      break;
    case "web_search_call":
      yield action({
        label: "streamingStatuses.web_search_call",
        status: "web_search_call",
        delay: 500,
      });
      break;
    case "image_generation_call":
      yield action({
        label: "streamingStatuses.image_generation_call",
        status: "image_generation_call",
      });
      break;
    case "return_file_as_json":
      yield action({
        label: "streamingStatuses.return_file_as_json",
        status: "return_file_as_json",
      });
      break;
    case "function_call_arguments":
      yield action({
        label: "streamingStatuses.function_call_arguments",
        status: "function_call_arguments",
      });
      break;
    case "video_generated_queued":
      yield action({
        label: "streamingStatuses.video_generated_queued",
        status: "video_generated_queued",
      });
      break;
    case "video_generated_in_progress":
      yield action({
        label: "streamingStatuses.video_generated_in_progress",
        status: "video_generated_in_progress",
      });
      break;
    case "generate_tts_request":
      yield action({
        label: "streamingStatuses.generate_tts_request",
        status: "generate_tts_request",
      });
      break;
    case "video_generated_completed":
      yield action({
        label: "streamingStatuses.video_generated_completed",
        status: "video_generated_completed",
      });
      break;
    case "completed":
      yield action({
        label: "",
        status: "completed",
      });
      break;
    default:
      yield action({ label: "", status: "" });
  }
}
